import { PlusOutlined } from '@ant-design/icons';
import { DndContext, DragOverlay } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { FormItem, useRelationEditor } from '@framework/form';
import { Alert } from 'antd';
import React, { useState } from 'react';
import { v4 } from 'uuid';
import { useBasicDndDragger } from '../../../../../../ui/dnd/hooks/useBasicDndDragger';
import { ITableRow } from '../ITableRow';
import { SortableTableRowItem } from './SortableTableRowItem';
import { TableRowView } from './TableRowView';
import { TableRowsWidgetEditDrawer } from './TableRowsWidgetEditDrawer';

export interface ITableRowsWidgetListProps {
  name: string;
}

/**
 * Componente con D'n'D per la configurazione della lista delle opzioni di widget checkbox/radio/select
 */
export function TableRowsWidgetList(props: ITableRowsWidgetListProps) {
  const { name } = props;

  const editor = useRelationEditor<ITableRow>(name);
  const [index, setIndex] = useState<number | null>(null);

  const { sensors, handleDragStart, handleDragEnd, itemIds, active } =
    useBasicDndDragger(editor);

  return (
    <div>
      {editor.items.length < 1 && (
        <Alert type="warning" showIcon message="Aggiungere almeno una riga" />
      )}

      <FormItem name={name} label={null}>
        <DndContext
          sensors={sensors}
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd}
          modifiers={[restrictToVerticalAxis]}
        >
          <SortableContext
            items={itemIds}
            strategy={verticalListSortingStrategy}
          >
            {editor.items.map((item, index) => (
              <SortableTableRowItem
                item={item}
                uid={item.__uid!}
                key={item.__uid}
                active={active}
                onEdit={e => {
                  editor.handle.open(item);
                }}
                onRemove={e => {
                  editor.remove(item);
                }}
                onAdd={e => {
                  setIndex(index + 1);
                  editor.handle.open({
                    id: v4(),
                    customRow: false,
                    label: [{ type: 'text', text: '' }],
                    code: '',
                  });
                }}
              />
            ))}
            <DragOverlay>
              {active && <TableRowView item={active} />}
            </DragOverlay>
          </SortableContext>
        </DndContext>

        {/* Pulsanti da aggiunta */}

        <TableRowsWidgetEditDrawer
          editor={editor}
          index={index}
          setIndex={setIndex}
          buttonProps={{
            type: 'dashed',
            size: 'large',
            icon: <PlusOutlined aria-hidden="true" />,
            block: true,
            children: 'Aggiungi Riga',
          }}
        />
      </FormItem>
    </div>
  );
}

{
  /* <WidgetOptionView item={active} /> */
}
{
  /* <SortableWidgetOptionItem
item={item}
uid={item.__uid!}
type={item.type}
key={item.__uid}
active={active}
onEdit={e => {
  editor.handle.open(item);
  e.preventDefault();
  e.stopPropagation();
}}
onRemove={e => {
  editor.remove(item);
  e.preventDefault();
  e.stopPropagation();
}}
onAdd={e => {
  setIndex(index + 1);
  editor.handle.open({
    label: '',
    value: '',
    type: 'option'
  });

  e.preventDefault();
  e.stopPropagation();
}}
/> */
}
